export function buildCrosshairTimeRange(
  fromSecs: number,
  toSecs: number,
  anchorSecs: number,
  locale: string,
): string {
  const clampedTo = Math.min(toSecs, anchorSecs);
  const dateOptions: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };
  const from = new Date(fromSecs * 1000);
  const dateLabel = from.toLocaleDateString(locale, dateOptions);
  const fromTime = from.toLocaleTimeString(locale, timeOptions);
  if (clampedTo <= fromSecs + 1) return `${dateLabel}, ${fromTime}`;

  const to = new Date(clampedTo * 1000);
  const toTime = to.toLocaleTimeString(locale, timeOptions);
  const sameDay =
    from.getFullYear() === to.getFullYear() &&
    from.getMonth() === to.getMonth() &&
    from.getDate() === to.getDate();
  if (sameDay) return `${dateLabel}, ${fromTime} – ${toTime}`;

  const toDate = to.toLocaleDateString(locale, dateOptions);
  return `${dateLabel} ${fromTime} – ${toDate} ${toTime}`;
}

export function buildLiveCrosshairTimeRange(
  fromSecs: number,
  toSecs: number,
  locale: string,
): string {
  return buildCrosshairTimeRange(fromSecs, toSecs, Math.floor(Date.now() / 1000), locale);
}
